// extracted by mini-css-extract-plugin
export default {"my-icon":"ThumbHover_my-icon__wXPsT","icon-hover":"ThumbHover_icon-hover__Mp+Nv"};